import Vue from 'vue'
import Vuex from 'vuex'
import { getListKodeSurat, listJenisSurat } from './services/surat'
import VuexPersistence from 'vuex-persist'
import { getBidangs, getJabatan } from './services/api'
import { jenisSurat } from '@/config/constants'

Vue.use(Vuex)

const privateRoles = ['Admin', 'Super Admin', 'Front Office']

const vuexLocal = new VuexPersistence({
  key: 'simsp',
  storage: window.localStorage,
  reducer: state => ({
    privateRoles: state.privateRoles,
    user: state.user,
    pejabats: state.pejabats,
    bidang: state.bidang,
    jenisSurat: state.jenisSurat
  })
})

export default new Vuex.Store({
  state: {
    user: null,
    suratMasukSet: {},
    suratKeluarSet: {},
    pejabats: [],
    loadingKodeSurat: false,
    kodeSurat: {
      data: [],
      pagination: { page: 1 }
    },
    bidang: [],
    privateRoles: [...privateRoles],
    jenisSurat
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_JABATANS(state, data) {
      state.pejabats = data
    },
    SET_LOADING_KODE_SURAT(state, isLoading = true) {
      state.loadingKodeSurat = isLoading
    },
    SET_KODE_SURAT(state, { data, pagination }) {
      state.kodeSurat = { data, pagination }
    },
    SET_BIDANG(state, data) {
      state.bidang = data
    },
    SET_JENIS_SURAT(state, data) {
      state.jenisSurat = data
    }
  },
  actions: {
    async fetchKodeSurat({ commit }, query = '') {
      try {
        commit('SET_LOADING_KODE_SURAT')
        if (query) {
          const splitQuery = query ? query.split(' - ') : query
          const q = Array.isArray(splitQuery) ? splitQuery[0] : query
          const res = await getListKodeSurat({ q: q.trim() })
          const { data, ...pagination } = res.data
          commit('SET_KODE_SURAT', { data, pagination })
        }
        commit('SET_LOADING_KODE_SURAT', false)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async loadBidang(context) {
      try {
        const { data } = await getBidangs()
        context.commit('SET_BIDANG', data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async loadJabatan(context) {
      try {
        const { data } = await getJabatan()
        context.commit('SET_JABATANS', data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async loadJenisSurat(context) {
      try {
        const { data } = await listJenisSurat()
        context.commit('SET_JENIS_SURAT', data)
      } catch (error) {
        return Promise.reject(error)
      }
    }
  },
  getters: {
    isAdmin(state) {
      if (state.user) {
        return state.user.is_admin
      }
      return false
    },
    hasPrivateAccess(state) {
      if (state.user) {
        const userRoles = state.user.roles.filter(role =>
          privateRoles
            .map(r => r.toLowerCase())
            .includes(role.name.toLowerCase())
        )
        return userRoles.length > 0
      }
      return false
    },
    roles(state) {
      return state.user.roles.map(r => r.name)
    },
    isSuperAdmin(state) {
      const superAdmin = state.user.roles.find(
        role => role.name === 'Super Admin'
      )
      return superAdmin ? true : false
    },
    isStaff(state) {
      const staff = state.user.roles.find(role => role.name === 'Staff')
      return staff ? true : false
    },
    isSekpri(state) {
      const staff = state.user.roles.find(role => role.name === 'Sekpri')
      return staff ? true : false
    },
    isLoggedin() {
      const token = localStorage.getItem('access_token')
      return Boolean(token)
    },
    jenisSurat(state) {
      return state.jenisSurat
    },
    getSuratMasukSet(state) {
      return state.suratMasukSet
    },
    getSuratKeluarSet(state) {
      return state.suratKeluarSet
    },
    getSuratMasukPageRows(state) {
      return state.suratMasukSet.currentPageRows
    },
    getSuratKeluarPageRows(state) {
      return state.suratKeluarSet.currentPageRows
    },
    getSuratMasukCurrentPage(state) {
      return state.suratMasukSet.currentPage
    },
    getSuratKeluarCurrentPage(state) {
      return state.suratKeluarSet.currentPage
    },
    getSuratMasukTotalPage(state) {
      return state.suratMasukSet.totalPage
    },
    getSuratMasukTotalRecordset(state) {
      return state.suratMasukSet.total
    },
    getSuratKeluarTotalRecordset(state) {
      return state.suratKeluarSet.total
    },
    getSuratKeluarTotalPage(state) {
      return state.suratKeluarSet.totalPage
    },
    getSuratMasukFirstRowNumber(state) {
      return state.suratMasukSet.from
    },
    getSuratKeluarFirstRowNumber(state) {
      return state.suratKeluarSet.from
    }
  },
  plugins: [vuexLocal.plugin]
})
